import { render, staticRenderFns } from "./ContributionsNavigation.vue?vue&type=template&id=3866718c&scoped=true"
import script from "./ContributionsNavigation.vue?vue&type=script&lang=ts"
export * from "./ContributionsNavigation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3866718c",
  null
  
)

export default component.exports